import type { BankAccountExpandOpts, GetBankAccountParams, IBankAccount } from '@condo/domain';
import { useQuery } from '@tanstack/vue-query';
import { type Ref, computed, isRef } from 'vue';

import { getBankAccounts } from '@/api/finance.api';

export const useBankAccounts = <T = IBankAccount>(
    queryOrRef: Partial<GetBankAccountParams> | Ref<Partial<GetBankAccountParams>>,
    transform?: (bankAccounts: IBankAccount[]) => T[],
    expandOpts?: BankAccountExpandOpts,
) => {
    const queryParams = computed(() => (isRef(queryOrRef) ? queryOrRef.value : queryOrRef));
    const queryEnabled = computed(() => !!queryParams.value);

    return useQuery(
        ['bank-accounts', queryParams],
        async () => {
            const bankAccountData = await getBankAccounts(queryParams.value, expandOpts);
            return bankAccountData.bankAccounts;
        },
        {
            enabled: queryEnabled,
            initialData: [],
            select: data => transform?.(data) ?? data,
        },
    );
};
